module.exports = __webpack_public_path__ + "img/404.7a716149.svg";